export default __webpack_public_path__ + "static/media/AO-5.20c7554d.jpg";